import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ICall } from '~/types/call/models'

const apiEntityPath = '/api/calls'

// export async function getCalls({ apiPath = '/api/calls' } = {}) {
//   const callingMn = getCalls.name
//   return httpGet<ICall[]>({ callingMn, apiPath })
// }

export async function createCall(entity: ICall) {
  const callingMn = createCall.name
  const apiPath = apiEntityPath
  return httpPost<ICall>({ callingMn, apiPath, entity })
}

export async function updateCall(entityData: Partial<ICall>, id: TEntityId) {
  const callingMn = updateCall.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialICall = Partial<ICall>
  return httpPatchMerge<TPartialICall>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteCall(entityData: ICall) {
  const callingMn = deleteCall.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
